import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/customButtom/CustomButton";
import TransparentButton from "../../../components/transparentButton/TransparentButton";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";

const SelectForm = () => {
  const navigate = useNavigate();
  const handleNaviation = (type) => {
    localStorage.setItem("userType", type);
    navigate("/auth/signup");
  };

  return (
    <div className="w-full flex flex-col items-center justify-center px-6 py-8 sm:p-10 bg-white relative overflow-y-auto h-screen">
      {/* Title */}
      <h1 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-2 text-center">
        Welcome to OnTrack Careers!
      </h1>
      <p className="text-gray-500 mb-6 text-sm sm:text-base text-center">
        Select your role to continue
      </p>

      {/* Buttons */}
      <div className="flex flex-col gap-4 w-full max-w-md">
        <CustomButton
          label="Join as a User"
          buttonClass="bg-custom-gradient py-3 sm:py-4 rounded-lg w-full text-base sm:text-lg font-semibold text-white hover:opacity-90 transition-all"
          onClick={() => handleNaviation("user")}
        />
        <TransparentButton
          buttonText="Apply to be a Mentor"
          buttonClass="border border-custom-blue text-custom-blue text-sm sm:text-base font-medium rounded-lg hover:bg-custom-blue hover:text-white py-3 sm:py-4 w-full transition-all"
          onClick={() => handleNaviation("mentor")}
        />
      </div>
    </div>
  );
};

export default SelectForm;
